import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import logoTransparent from "../../assets/images/logo/logo_transparent.png";
import { ProfileIcon, MenuLinesIcon } from "../../assets/icons";

const Navbar = ({ onMenuClick, hideLogo = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.user);
  const { profile } = useSelector((state) => state.global);

  const getUserDisplayName = () => {
    if (!user) return "Admin";
    return profile.name || user.name;
  };

  const getPageName = () => {
    const path = location.pathname;
    switch (path) {
      case "/":
        return "Dashboard";
      case "/users":
        return "Users Management";
      case "/modal-answer":
        return "Model Answer";
      case "/submissions":
        return "Submissions";
      case "/flagged":
        return "Flagged Essays";
      default:
        return "Dashboard";
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm border-b border-gray-200 lg:relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center lg:hidden">
            <button
              onClick={onMenuClick}
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500 transition-colors duration-200"
              aria-label="Toggle menu"
            >
              <MenuLinesIcon className="h-8 w-10" />
            </button>
          </div>
          {!hideLogo && (
            <div className="flex items-center justify-center flex-1 lg:hidden">
              <div className="flex flex-col items-center">
                <button
                  onClick={() => navigate("/")}
                  className="flex flex-col items-center hover:opacity-80 transition-opacity duration-200"
                >
                  <img
                    src={logoTransparent}
                    alt="Calbar Logo"
                    className="h-8 w-auto mb-1"
                  />
                  <span className="text-sm font-medium text-gray-700">
                    {getPageName()}
                  </span>
                </button>
              </div>
            </div>
          )}
          <div className="hidden lg:flex items-center flex-1 justify-center">
            <h1 className="text-xl font-semibold text-gray-900">
              {getPageName()}
            </h1>
          </div>
          <div className="flex items-center ml-auto">
            <div className="flex items-center space-x-3">
              <button
                onClick={() => navigate("/profile")}
                className="p-2 rounded-full text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500 transition-colors duration-200"
                aria-label="Profile"
              >
                <ProfileIcon className="h-6 w-6" />
              </button>
              <div className="hidden sm:block">
                <span className="text-sm font-medium text-gray-700">
                  {getUserDisplayName()}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
